/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react.old';

import * as Common from './common';


const SolidLinePath = styled(Common.Path)`

  stroke-width: ${props => Common.getLineStroke(props) / 4};
`;


const DottedLinePath = styled(Common.Path)`

  stroke-width: ${props => Common.getLineStroke(props)};
  stroke-dasharray: ${props => Common.getLineStrokeDasharray(props)};
`;


const ArrowPath = styled(Common.Path)`

  fill: var(--svg-always-black);

  stroke-width: ${props => Common.getArrowStroke(props)};
`;


const getLinePath = (props) =>
{
  const length = Common.getLineLength(props);

  return `M ${length / 2} ${0} L ${- length / 2} ${0}`
}


const getArrowPath = (props) =>
{
  const length   = Common.getArrowLength(props) * Common.getArrowReverseOnIncomming(props);
  const width    = Common.getArrowWidth(props);
  const endPoint = Common.getArrowEndPoint(props);

  return `M ${endPoint} 0 l ${length} ${-width} l 0 ${2 * width} l ${-length} ${-width} Z`;
}


const Line = ({ solidLine, arrowOnly, ...props }) =>
{
  if (arrowOnly)
  {
    return null;
  }

  if (solidLine)
  {
    return <SolidLinePath {...props} d = {getLinePath(props)} />;
  }

  return <DottedLinePath {...props} d = {getLinePath(props)} />;
}


/*
 * Modifiers:
 * - solidLine   - draws solid line instead of dotted one.
 * - onlyArrow   - doesn't draw the line.
 * - centerArrow - centers arrow in between the external borders.
 * - reverse     - draws reversed arrow.
 */
export default (props) =>
(
  <>
    <Line {...props} />
    <ArrowPath {...props} d = {getArrowPath(props)} />
  </>
);
